// @ts-nocheck

import { saveToStorage } from '../../actions/multiview';
import { MultiviewStorage } from '../../constants/multiview';
import { MultiviewActionTypes } from '../../types/actions/multiview';
import StorageUtils from '../../utils/storage';
import { type HandlerProps } from '../synchronousMiddleware';

export const handledActionTypes = [
  MultiviewActionTypes.SET_DISPLAY_MODE,
  MultiviewActionTypes.ADD_MATCH,
  MultiviewActionTypes.DEL_MATCH,
  MultiviewActionTypes.SET_ITEM_PER_LINE,
  MultiviewActionTypes.SET_SHOW_MATCH_LIST,
  MultiviewActionTypes.SET_DISPLAY_OPTIONS,
  MultiviewActionTypes.SAVE_TO_STORAGE,
  MultiviewActionTypes.SET_USER_OPTION,
  MultiviewActionTypes.SET_SCROLL_TO_HEADER,
];

const multiviewMiddlewareHandler = ({ store: { getState, dispatch }, action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    if (action.type.match('^multiview/(?!saveToStorage)')) {
      dispatch(saveToStorage());
    }

    if (action.type === MultiviewActionTypes.SAVE_TO_STORAGE) {
      StorageUtils.sessionStorage.save(MultiviewStorage.KEY, {
        state: getState().multiview,
        version: MultiviewStorage.VERSION,
      });
    }
  }
};

export default multiviewMiddlewareHandler;
